import React from 'react';
import { connect } from 'react-redux';
import api from '../../../utils/api';
import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';
import { push } from 'connected-react-router';

class DeleteBranchView extends React.Component {
    onSubmit = values => {};

    componentWillReceiveProps = nextProps => {};

    constructor(props) {
        super(props);
    }

    componentDidMount = () => {};

    handleClose = () => {
        this.props.dispatch(push('/branches'));
    };

    submitForm = () => {
        this.props.deleteBranch({ branch_id: this.props.match.params.branch_id });
    };

    render = () => {
        const actions = [
            <FlatButton label="Abbrechen" primary={true} onClick={this.handleClose} />,
            <FlatButton
                label="Filiale löschen"
                primary={true}
                keyboardFocused={true}
                onClick={this.submitForm}
            />,
        ];

        return (
            <div>
                <Dialog
                    title="Filiale löschen"
                    modal={false}
                    actions={actions}
                    open={true}
                    onRequestClose={this.handleClose}>
                    Sind Sie sicher, dass Sie die Filiale löschen wollen?
                </Dialog>
            </div>
        );
    };
}

const mapStateToProps = (state, props) => ({});

const mapDispatchToProps = dispatch => ({
    dispatch,
    deleteBranch: payload => dispatch(api.actions.branches.deleteBranch(payload)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DeleteBranchView);
